export default __webpack_public_path__ + "static/media/C0004.12a56879.png";